import React, { useEffect, useMemo, useState } from 'react';
import { Modal, Form, Input, Select, Message } from '@b-design/fusion';
import Button from '@/components/Button';
import { history } from 'ice';
import $i18n from '../../../../../i18n';
import Requests from '@/services/request';
import { getQueryStringArgs } from '@/utils/url-parse';
import store from '@/store';

import './index.less';

interface Props {
  channelVisible: boolean;
  setChannelVisisble: any;
  currInfoVersion: string;
  info: any;
  toJsapiTab: (type: string) => void;
}

const ChooseChannelModal: React.FC<Props> = ({
  channelVisible,
  setChannelVisisble,
  currInfoVersion,
  toJsapiTab,
  info,
}) => {
  const { appId, spaceId } = getQueryStringArgs();
  const [list, setList] = useState<any>([]);
  const [showDialog, setShowDialog] = useState(false);
  const [channel, setChannel] = useState('');
  const [spaceRoleState] = store.useModel('spaceRole');
  const [modal, setModal] = useState('');

  useEffect(() => {
    if (channelVisible) {
      setChannel('');
      Requests.get('/rest/intercnn/publishChannel/pageQuery', {
        currentPage: 1,
        pageSize: 10000,
        draftStatus: 'ONLINE',
        spaceId,
        belongSpaceId: spaceRoleState?.belongSpaceId || '',
      }).then((data) => {
        const { list: allPublish = [] } = data;
        Requests.get('/rest/intercnn/app/publish/version/query', {
          appId,
          version: currInfoVersion,
        }).then((res) => {
          const { list: toVersion } = res;
          let resList = allPublish;
          for (let i = 0; i < toVersion.length; i++) {
            resList = resList.filter((item) => item.innerCode !== toVersion[i].channelCode);
          }
          setList(resList);
          setShowDialog(true);
        });
      });
    } else {
      setModal('');
      setShowDialog(false);
    }
  }, [channelVisible]);

  const changeChannel = (value) => {
    setChannel(value);
  };

  useEffect(() => {
    if (info?.framework != 'WindVane') {
      setModal('selectChannel');
      return;
    }
    if (channelVisible) {
      if (!showDialog) {
        setModal('');
      } else if (!list || list?.length === 0) {
        setModal('selectChannel');
      } else {
        const flag = list.some((item) => item.jsapiEnable === 1);
        if (flag) {
          setModal('toJsapiApply&urlApply');
        } else {
          setModal('urlApply');
        }
      }
    } else {
      setModal('');
    }
  }, [list, channelVisible, info, showDialog]);

  const submit = async () => {
    if (channel) {
      const res = await Requests.post('/rest/intercnn/app/publish/version/create', {
        appId,
        channelCode: channel,
        version: currInfoVersion,
        changelog: '',
      });
      if (res) {
          Message.success({
            title: $i18n.get({
              id: 'aopf.pages.miniapp.versions.form.submit.msg',
              dm: '提交成功',
            }),
          });
          history?.push(
            `/miniapp/version?spaceId=${spaceId || ''}&appId=${appId}&channelCode=${channel}&version=${currInfoVersion}`,
          );
        }
    } else {
      Message.error({
        title: $i18n.get({
          id: 'aopf.pages.miniapp.versions.Please.select.the.channel',
          dm: '请选择渠道',
        }),
      });
    }
  };

  const cancel = () => {
    setModal('selectChannel');
  };
  const toAplly = (type) => {
    toJsapiTab(type);
    setChannelVisisble(false);
  };

  return (
    <div className="modal-choose-channel-container">
      {modal === 'toJsapiApply&urlApply' && (
        <Modal
          // title={$i18n.get({
          //   id: 'aopf.pages.miniapp.versions.table.Action.Distribute.Channel.modal.toApplyJsapiTitle',
          //   dm: '是否需要申请 JSAPI 授权',
          // })}
          width={460}
          data-size="small"
          visible={channelVisible}
          onCancel={() => setChannelVisisble(false)}
          onClose={() => setChannelVisisble(false)}
          footer={false}
          closeMode={[]}
          className="to-jsapi-apply-tip-modal"
          // footer={[
          //   <Button onClick={() => cancel()}>
          //     {$i18n.get({
          //       id: 'aopf.pages.miniapp.versions.table.Action.Distribute.Channel.modal.btn.noApply',
          //       dm: '不需要',
          //     })}
          //   </Button>,
          //   <Button type="primary" onClick={() => toAplly()} style={{ marginLeft: 10 }}>
          //     {$i18n.get({
          //       id: 'aopf.pages.miniapp.versions.table.Action.Distribute.Channel.modal.btn.toApplyJsapi',
          //       dm: '前往申请',
          //     })}
          //   </Button>,
          // ]}
        >
          <div className="to-jsapi-apply-tip-content">
            <div className="tip-item">
              <div>
                {$i18n.get({
                  id: 'aopf.component.chooseChannelModal.DoYouNeedToApply',
                  dm: '是否需要申请 JSAPI 授权',
                })}
              </div>
              <Button type="primary" size="small" onClick={() => toAplly('JsApiFeatures')}>
                {$i18n.get({ id: 'aopf.component.chooseChannelModal.GoNow', dm: '立即前往' })}
              </Button>
            </div>
            <div className="tip-item">
              <div>
                {$i18n.get({
                  id: 'aopf.component.chooseChannelModal.DoYouNeedToApply.1',
                  dm: '是否需要申请小程序跳转',
                })}
              </div>
              <Button size="small" type="primary" onClick={() => toAplly('MiniappsRedirectURL')}>
                {$i18n.get({ id: 'aopf.component.chooseChannelModal.GoNow', dm: '立即前往' })}
              </Button>
            </div>
            <Button className="all-no-btn" onClick={() => cancel()}>
              {$i18n.get({ id: 'aopf.component.chooseChannelModal.NoNeed', dm: '都不需要' })}
            </Button>
          </div>
        </Modal>
      )}

      {modal === 'urlApply' && (
        <Modal
          title={$i18n.get({
            id: 'aopf.component.chooseChannelModal.DoYouNeedToApply.1',
            dm: '是否需要申请小程序跳转',
          })}
          width={460}
          data-size="small"
          visible={channelVisible}
          onCancel={() => setChannelVisisble(false)}
          onClose={() => setChannelVisisble(false)}
          closeMode={[]}
          className="to-jsapi-apply-tip-modal"
          footer={[
            <Button onClick={() => cancel()}>
              {$i18n.get({
                id: 'aopf.pages.miniapp.versions.table.Action.Distribute.Channel.modal.btn.noApply',
                dm: '不需要',
              })}
            </Button>,
            <Button
              type="primary"
              onClick={() => toAplly('MiniappsRedirectURL')}
              style={{ marginLeft: 10 }}
            >
              {$i18n.get({
                id: 'aopf.pages.miniapp.versions.table.Action.Distribute.Channel.modal.btn.toApplyJsapi',
                dm: '前往申请',
              })}
            </Button>,
          ]}
        />
      )}

      {modal === 'selectChannel' && (
        <Modal
          title={$i18n.get({
            id: 'aopf.pages.miniapp.versions.table.Action.Distribute.Channel.modal.title',
            dm: '选择渠道',
          })}
          data-size="small"
          visible={channelVisible}
          onCancel={() => setChannelVisisble(false)}
          onClose={() => setChannelVisisble(false)}
          footer={[
            <Button onClick={() => setChannelVisisble(false)}>
              {$i18n.get({
                id: 'aopf.pages.miniapp.versions.table.Action.Distribute.Channel.modal.btn.cancel',
                dm: '取消',
              })}
            </Button>,
            <Button type="primary" onClick={submit} style={{ marginLeft: 10 }}>
              {$i18n.get({
                id: 'aopf.pages.miniapp.versions.table.Action.Distribute.Channel.modal.btn.ok',
                dm: '确定',
              })}
            </Button>,
          ]}
        >
          <Form style={{ maxWidth: '350px', paddingLeft: '30px' }}>
            <Form.Item
              name="version"
              label={$i18n.get({
                id: 'aopf.pages.miniapp.versions.table.Action.Distribute.Channel.modal.Version',
                dm: '版本',
              })}
              required
            >
              <Input
                placeholder={$i18n.get({
                  id: 'aopf.component.chooseChannelModal.PleaseEnter',
                  dm: '请输入',
                })}
                value={currInfoVersion}
                disabled
              />
            </Form.Item>
            <Form.Item
              name="channel"
              label={$i18n.get({
                id: 'aopf.pages.miniapp.versions.table.Action.Distribute.Channel.modal.Target.APP',
                dm: '当前应用',
              })}
              required
            >
              <Select
                placeholder={$i18n.get({
                  id: 'aopf.pages.miniapp.versions.Please.select.the.channel',
                  dm: '请选择渠道',
                })}
                style={{ width: '100%' }}
                popupProps={{ v2: true }}
                popupClassName="b-design-select"
                onChange={changeChannel}
              >
                {list.map((item) => (
                  <Select.Option value={item.innerCode} key={item.innerCode}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <img src={item.iconPublicUrl} style={{ width: 15, height: 15 }} alt="" />
                      {item.name}
                    </div>
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Form>
        </Modal>
      )}
    </div>
  );
};

export default ChooseChannelModal;
